import { render } from "./Langauge.vue?vue&type=template&id=3de16786&scoped=true&ts=true"
import script from "./Langauge.vue?vue&type=script&lang=ts"
export * from "./Langauge.vue?vue&type=script&lang=ts"

import "./Langauge.vue?vue&type=style&index=0&id=3de16786&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de16786"]])

export default __exports__